(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if (!customElements.get('namami-studio-filter')) {
  customElements.define('namami-studio-filter', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.selected = 'all';
      this.selector = this.querySelector('.namami-studio-selector');
      this.buttons = Array.from(this.querySelectorAll('[data-studio-view]'));
      this.status = this.querySelector('[role="status"]');
      this.emptyMessage = this.querySelector('.namami-studio-no-results');
      this.onClick = (event) => {
        const button = event.target.closest('[data-studio-view]');
        if (!button) return;
        this.selected = button.dataset.studioView;
        this.apply();
      };
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.apply());
      const connect = () => {
        const grid = this.section.querySelector('#ProductGridContainer');
        if (grid) this.observer.observe(grid, { childList: true, subtree: true });
        this.apply();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', connect, { once: true });
      } else connect();
    }
    apply() {
      const items = Array.from(this.section.querySelectorAll('#product-grid > [data-studio-kind]'));
      const counts = { all: items.length, edition: 0, seconds: 0 };
      items.forEach((item) => {
        if (item.dataset.studioKind in counts) counts[item.dataset.studioKind]++;
        item.hidden = this.selected !== 'all' && item.dataset.studioKind !== this.selected;
      });
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.studioView === this.selected)));
      const index = this.buttons.findIndex((button) => button.dataset.studioView === this.selected);
      this.selector.style.setProperty('--studio-index', index);
      const active = this.buttons[index];
      const count = counts[this.selected] || 0;
      const label = `${count} ${this.status.dataset.countLabel}`;
      this.status.textContent = `${active.textContent}: ${label}`;
      this.emptyMessage.hidden = count > 0 || items.length === 0;
      this.section.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach((element) => {
        if (element.textContent.trim() !== label) element.textContent = label;
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namami-azulik-film"] && !Shopify.designMode) return;
  try {
    
function initializeAzulikFilms(root) {
  root.querySelectorAll('video[data-azulik-film]').forEach(function(video) {
    if (video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    video.muted = true;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection && navigator.connection.saveData;
    let manuallyPaused = false;
    let automaticPause = false;
    video.addEventListener('pause', function() {
      if (!automaticPause && video.currentTime > 0) manuallyPaused = true;
      automaticPause = false;
    });
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (!reducedMotion.matches && !saveData && !manuallyPaused) {
            video.play().catch(function() {});
          }
        } else if (!video.paused) {
          automaticPause = true;
          video.pause();
        }
      });
    }, { threshold: 0.15 });
    observer.observe(video);
    reducedMotion.addEventListener('change', function(event) {
      if (event.matches && !video.paused) {
        automaticPause = true;
        video.pause();
      }
    });
  });
}
initializeAzulikFilms(document);
document.addEventListener('shopify:section:load', function(event) {
  initializeAzulikFilms(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namami-harp-echo-glow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('namami-harp-echo-colour-glow')) {
 customElements.define('namami-harp-echo-colour-glow', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller=new AbortController(); const opts={signal:this.controller.signal};
   this.range=this.querySelector('[data-range]');
   this.pairs=Array.from(this.querySelectorAll('[data-pair]'));
   this.swatches=Array.from(this.querySelectorAll('[data-colour]'));
   if(!this.range||!this.pairs.length)return;
   const nativeName='options['+this.dataset.optionName+']';
   this.nativeInput=()=>Array.from(document.querySelectorAll('variant-selects select')).find(e=>e.name===nativeName);
   const normalize=v=>(v||'').normalize('NFC').toLowerCase().trim();
   this.show=(value,fromProduct=false)=>{
    const match=this.pairs.find(p=>normalize(p.dataset.pair)===normalize(value));
    const active=match||this.pairs[0];this.selectedColour=active.dataset.pair;
    this.pairs.forEach(p=>p.hidden=p!==active);
    this.swatches.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.colour===this.selectedColour)));
    this.querySelector('[data-colour-name]').textContent=this.selectedColour.replace(/^noir$/i,'Noir');
    this.querySelectorAll('[data-caption]').forEach(p=>p.hidden=p.dataset.caption!==this.selectedColour);
    this.querySelector('[data-missing]').hidden=!(fromProduct&&value&&!match);
   };
   this.updateGlow=()=>{
    this.style.setProperty('--iris-glow',Number(this.range.value)/100);
    this.querySelector('[data-glow-output]').textContent=this.range.value+'%';
    this.range.setAttribute('aria-valuetext',this.range.value+'% photographic glow preview');
   };
   this.range.addEventListener('input',this.updateGlow,opts);
   this.swatches.forEach(b=>b.addEventListener('click',()=>this.show(b.dataset.colour),opts));
   const link=this.querySelector('[data-purchase]');
   const info=document.querySelector('product-info[id]');if(info)link.href='#'+info.id;
   link.addEventListener('click',()=>{
    const input=this.nativeInput();
    if(input&&Array.from(input.options).some(o=>o.value===this.selectedColour)&&input.value!==this.selectedColour){
     input.value=this.selectedColour;input.dispatchEvent(new Event('change',{bubbles:true}));
    }
   },opts);
   document.addEventListener('change',e=>{if(e.target.name===nativeName)this.show(e.target.value,true);},opts);
   this.show(this.nativeInput()?.value||this.pairs[0].dataset.pair,true);this.updateGlow();
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namami-iris-table-glow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('iris-light-preview')) {
  customElements.define('iris-light-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.range = this.querySelector('[data-range]');
      this.swatches = Array.from(this.querySelectorAll('[data-colour]'));
      this.pairs = Array.from(this.querySelectorAll('[data-pair]'));
      this.nativeInput = () => Array.from(document.querySelectorAll('variant-selects select')).find(input => input.name === 'options[' + this.dataset.optionName + ']');
      this.show = value => {
        const active = this.pairs.find(pair => pair.dataset.pair === value) || this.pairs[0];
        if (!active) return;
        this.selectedColour = active.dataset.pair;
        this.pairs.forEach(pair => pair.hidden = pair !== active);
        this.swatches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colour === this.selectedColour)));
        this.querySelector('[data-colour-name]').textContent = this.selectedColour;
        this.querySelectorAll('[data-caption]').forEach(caption => caption.hidden = caption.dataset.caption !== this.selectedColour);
        const single = active.dataset.static === 'true';
        this.querySelector('.iris-light__controls').hidden = single;
        this.querySelector('.iris-light__status').hidden = !single;
      };
      this.updateGlow = () => {
        this.style.setProperty('--iris-glow', Number(this.range.value) / 100);
        this.querySelector('[data-glow-output]').textContent = this.range.value + '%';
        this.range.setAttribute('aria-valuetext', this.range.value + '% photographic glow preview');
      };
      this.range.addEventListener('input', this.updateGlow, options);
      this.swatches.forEach(button => button.addEventListener('click', () => this.show(button.dataset.colour), options));
      this.querySelector('.iris-light__link').addEventListener('click', () => {
        const input = this.nativeInput();
        if (input && input.value !== this.selectedColour) {
          input.value = this.selectedColour;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, options);
      document.addEventListener('change', event => {
        if (event.target.name === 'options[' + this.dataset.optionName + ']') this.show(event.target.value);
      }, options);
      this.show(this.nativeInput()?.value || this.swatches[0]?.dataset.colour);
      this.updateGlow();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namami-mycelia-glow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('namami-colour-glow')) {
 customElements.define('namami-colour-glow', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller=new AbortController(); const opts={signal:this.controller.signal};
   this.range=this.querySelector('[data-range]');
   this.pairs=Array.from(this.querySelectorAll('[data-pair]'));
   this.swatches=Array.from(this.querySelectorAll('[data-colour]'));
   if(!this.range||!this.pairs.length)return;
   const nativeName='options['+this.dataset.optionName+']';
   this.nativeInput=()=>Array.from(document.querySelectorAll('variant-selects select')).find(e=>e.name===nativeName);
   const normalize=v=>(v||'').normalize('NFC').toLowerCase().trim();
   this.show=(value,fromProduct=false)=>{
    const match=this.pairs.find(p=>normalize(p.dataset.pair)===normalize(value));
    const active=match||this.pairs[0];this.selectedColour=active.dataset.pair;
    this.pairs.forEach(p=>p.hidden=p!==active);
    this.swatches.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.colour===this.selectedColour)));
    this.querySelector('[data-colour-name]').textContent=this.selectedColour;
    this.querySelectorAll('[data-caption]').forEach(p=>p.hidden=p.dataset.caption!==this.selectedColour);
    this.querySelector('[data-missing]').hidden=!(fromProduct&&value&&!match);
   };
   this.updateGlow=()=>{
    this.style.setProperty('--iris-glow',Number(this.range.value)/100);
    this.querySelector('[data-glow-output]').textContent=this.range.value+'%';
    this.range.setAttribute('aria-valuetext',this.range.value+'% photographic glow preview');
   };
   this.range.addEventListener('input',this.updateGlow,opts);
   this.swatches.forEach(b=>b.addEventListener('click',()=>this.show(b.dataset.colour),opts));
   const link=this.querySelector('[data-purchase]');
   const info=document.querySelector('product-info[id]');if(info)link.href='#'+info.id;
   link.addEventListener('click',()=>{
    const input=this.nativeInput();
    if(input&&Array.from(input.options).some(o=>o.value===this.selectedColour)&&input.value!==this.selectedColour){
     input.value=this.selectedColour;input.dispatchEvent(new Event('change',{bubbles:true}));
    }
   },opts);
   document.addEventListener('change',e=>{if(e.target.name===nativeName)this.show(e.target.value,true);},opts);
   this.show(this.nativeInput()?.value||this.pairs[0].dataset.pair,true);this.updateGlow();
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namami-orb-glow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('namami-orb-colour-glow')) {
 customElements.define('namami-orb-colour-glow', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller=new AbortController(); const opts={signal:this.controller.signal};
   this.range=this.querySelector('[data-range]');
   this.pairs=Array.from(this.querySelectorAll('[data-pair]'));
   this.swatches=Array.from(this.querySelectorAll('[data-colour]'));
   if(!this.range||!this.pairs.length)return;
   const nativeName='options['+this.dataset.optionName+']';
   this.nativeInput=()=>Array.from(document.querySelectorAll('variant-selects select')).find(e=>e.name===nativeName);
   const normalize=v=>(v||'').normalize('NFC').toLowerCase().trim();
   this.show=(value,fromProduct=false)=>{
    const match=this.pairs.find(p=>normalize(p.dataset.pair)===normalize(value));
    const active=match||this.pairs[0];this.selectedColour=active.dataset.pair;
    this.pairs.forEach(p=>p.hidden=p!==active);
    this.swatches.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.colour===this.selectedColour)));
    this.querySelector('[data-colour-name]').textContent=this.selectedColour.replace(/^noir$/i,'Noir');
    this.querySelectorAll('[data-caption]').forEach(p=>p.hidden=p.dataset.caption!==this.selectedColour);
    this.querySelector('[data-missing]').hidden=!(fromProduct&&value&&!match);
   };
   this.updateGlow=()=>{
    this.style.setProperty('--iris-glow',Number(this.range.value)/100);
    this.querySelector('[data-glow-output]').textContent=this.range.value+'%';
    this.range.setAttribute('aria-valuetext',this.range.value+'% photographic glow preview');
   };
   this.range.addEventListener('input',this.updateGlow,opts);
   this.swatches.forEach(b=>b.addEventListener('click',()=>this.show(b.dataset.colour),opts));
   const link=this.querySelector('[data-purchase]');
   const info=document.querySelector('product-info[id]');if(info)link.href='#'+info.id;
   link.addEventListener('click',()=>{
    const input=this.nativeInput();
    if(input&&Array.from(input.options).some(o=>o.value===this.selectedColour)&&input.value!==this.selectedColour){
     input.value=this.selectedColour;input.dispatchEvent(new Event('change',{bubbles:true}));
    }
   },opts);
   document.addEventListener('change',e=>{if(e.target.name===nativeName)this.show(e.target.value,true);},opts);
   this.show(this.nativeInput()?.value||this.pairs[0].dataset.pair,true);this.updateGlow();
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namami-ori-glow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('namami-ori-colour-glow')) {
 customElements.define('namami-ori-colour-glow', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller=new AbortController(); const opts={signal:this.controller.signal};
   this.range=this.querySelector('[data-range]');
   this.pairs=Array.from(this.querySelectorAll('[data-pair]'));
   this.swatches=Array.from(this.querySelectorAll('[data-colour]'));
   if(!this.range||!this.pairs.length)return;
   const nativeName='options['+this.dataset.optionName+']';
   this.nativeInput=()=>Array.from(document.querySelectorAll('variant-selects select')).find(e=>e.name===nativeName);
   const normalize=v=>(v||'').normalize('NFC').toLowerCase().trim();
   this.show=(value,fromProduct=false)=>{
    const match=this.pairs.find(p=>normalize(p.dataset.pair)===normalize(value));
    const active=match||this.pairs[0];this.selectedColour=active.dataset.pair;
    this.pairs.forEach(p=>p.hidden=p!==active);
    this.swatches.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.colour===this.selectedColour)));
    this.querySelector('[data-colour-name]').textContent=this.selectedColour.replace(/^noir$/i,'Noir');
    this.querySelectorAll('[data-caption]').forEach(p=>p.hidden=p.dataset.caption!==this.selectedColour);
    this.querySelector('[data-missing]').hidden=!(fromProduct&&value&&!match);
   };
   this.updateGlow=()=>{
    this.style.setProperty('--iris-glow',Number(this.range.value)/100);
    this.querySelector('[data-glow-output]').textContent=this.range.value+'%';
    this.range.setAttribute('aria-valuetext',this.range.value+'% photographic glow preview');
   };
   this.range.addEventListener('input',this.updateGlow,opts);
   this.swatches.forEach(b=>b.addEventListener('click',()=>this.show(b.dataset.colour),opts));
   const link=this.querySelector('[data-purchase]');
   const info=document.querySelector('product-info[id]');if(info)link.href='#'+info.id;
   link.addEventListener('click',()=>{
    const input=this.nativeInput();
    if(input&&Array.from(input.options).some(o=>o.value===this.selectedColour)&&input.value!==this.selectedColour){
     input.value=this.selectedColour;input.dispatchEvent(new Event('change',{bubbles:true}));
    }
   },opts);
   document.addEventListener('change',e=>{if(e.target.name===nativeName)this.show(e.target.value,true);},opts);
   let variants=[];try{variants=JSON.parse(this.querySelector('[data-ori-variants]')?.textContent||'[]');}catch(e){}
   document.addEventListener('click',e=>{
    const sizeLink=e.target.closest('#ori-sizes .iris-guide__link');if(!sizeLink||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
    const targetId=new URL(sizeLink.href,location.href).searchParams.get('variant');
    const target=variants.find(v=>String(v.id)===targetId);
    const colour=this.nativeInput()?.value||this.selectedColour;
    const match=target&&variants.find(v=>v.option1===colour&&v.option2===target.option2);if(!match)return;
    e.preventDefault();e.stopImmediatePropagation();
    const productInfo=document.querySelector('product-info[id]');
    const destination=new URL(sizeLink.href,location.href);destination.searchParams.set('variant',match.id);destination.hash=productInfo?.id||'';
    location.assign(destination.href);
   },{...opts,capture:true});
   this.show(this.nativeInput()?.value||this.pairs[0].dataset.pair,true);this.updateGlow();
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namami-product-glow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('namami-product-light-preview')) {
  customElements.define('namami-product-light-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.range = this.querySelector('[data-range]');
      this.swatches = Array.from(this.querySelectorAll('[data-colour]'));
      this.pairs = Array.from(this.querySelectorAll('[data-pair]'));
      this.nativeInput = () => Array.from(document.querySelectorAll('variant-selects select')).find(input => input.name === 'options[' + this.dataset.optionName + ']');
      this.show = value => {
        const active = this.pairs.find(pair => pair.dataset.pair === value) || this.pairs[0];
        if (!active) return;
        this.selectedColour = active.dataset.pair;
        this.pairs.forEach(pair => pair.hidden = pair !== active);
        this.swatches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colour === this.selectedColour)));
        this.querySelector('[data-colour-name]').textContent = this.selectedColour;
        this.querySelectorAll('[data-caption]').forEach(caption => caption.hidden = caption.dataset.caption !== this.selectedColour);
        const single = active.dataset.static === 'true';
        this.querySelector('.iris-light__controls').hidden = single;
        const missing = active.dataset.pair !== value;
        this.querySelector('.iris-light__status').hidden = !single && !missing;
        this.querySelector('.iris-light__status').textContent = missing
          ? 'On/off photographs for your selected colour are coming soon. Choose a colour below to explore the available photos.'
          : this.dataset.singleNote;
      };
      this.updateGlow = () => {
        this.style.setProperty('--iris-glow', Number(this.range.value) / 100);
        this.querySelector('[data-glow-output]').textContent = this.range.value + '%';
        this.range.setAttribute('aria-valuetext', this.range.value + '% photographic glow preview');
      };
      this.range.addEventListener('input', this.updateGlow, options);
      this.swatches.forEach(button => button.addEventListener('click', () => this.show(button.dataset.colour), options));
      this.querySelector('.iris-light__link').addEventListener('click', event => {
        event.preventDefault();
        const input = this.nativeInput();
        if (input && input.value !== this.selectedColour) {
          input.value = this.selectedColour;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, options);
      document.addEventListener('change', event => {
        if (event.target.name === 'options[' + this.dataset.optionName + ']') this.show(event.target.value);
      }, options);
      this.show(this.nativeInput()?.value || this.swatches[0]?.dataset.colour);
      this.updateGlow();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();
})();
